import SmoothScroll from 'smooth-scroll';

const detail = () =>
{
    const btn = document.querySelector('.js-sub_header');
    if (!btn) return;

    /* =========================
       offset計算（ヘッダー＋サブなど全部）
    ========================= */
    const getOffset = () => {
        const selectors = ['.header', '.js-sub_header'];

        return selectors.reduce((total, selector) => {
            const el = document.querySelector(selector);
            return total + (el?.offsetHeight ?? 0);
        }, 0) + 10; // 微調整
    };

    /* =========================
       スムーススクロール
    ========================= */
    const scroll = new SmoothScroll('a[href*="#"]', {
        speed: 100,
        speedAsDuration: true,
        easing: 'easeInOutCubic',
        offset: getOffset
    });

    /* =========================
       active切替
    ========================= */
    const sections = document.querySelectorAll('#report, #estate, #layout');
    const navLinks = document.querySelectorAll('.js-fixed_navi');

    const setActive = (id) => {
        navLinks.forEach(link => {
            link.classList.toggle(
                'is-active',
                link.getAttribute('href') === `#${id}`
            );
        });
    };

    /* =========================
       Intersection Observer
    ========================= */
    const createObserver = () => {
        const offset = getOffset();

        return new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setActive(entry.target.id);
                }
            });
        }, {
            root: null,
            rootMargin: `-${offset}px 0px -50% 0px`,
            threshold: 0
        });
    };

    let observer = createObserver();

    sections.forEach(section => observer.observe(section));

    /* =========================
       クリック時 即active（UX改善）
    ========================= */
    navLinks.forEach(link => {
        link.addEventListener('click', () => {
            navLinks.forEach(l => l.classList.remove('is-active'));
            link.classList.add('is-active');
        });
    });

    /* =========================
       初期表示時 active補正
    ========================= */
    window.addEventListener('load', () => {
        const offset = getOffset();

        sections.forEach(section => {
            const rect = section.getBoundingClientRect();

            if (rect.top <= offset + window.innerHeight * 0.3 && rect.bottom > offset) {
                setActive(section.id);
            }
        });
    });

    /* =========================
       リサイズ時に再計算（重要）
    ========================= */
    window.addEventListener('resize', () => {
        observer.disconnect();
        observer = createObserver();
        sections.forEach(section => observer.observe(section));
    });

    /* =========================
       ナビスクロール制御（SP のみ）
       下スクロール: data-hidden を付与して非表示
       上スクロール: data-hidden を除去して表示
    ========================= */
    const BP_SM = 640; // @include sm の閾値
    const mq = window.matchMedia(`(max-width: ${BP_SM}px)`);
    const nav = document.querySelector('.pg-content-navi');
    let lastY = window.scrollY;

    const onScroll = () => {
        if (!mq.matches) return;

        const currentY = window.scrollY;
        const isScrollingDown = currentY > lastY && currentY > nav.offsetHeight;

        nav.toggleAttribute('data-hidden', isScrollingDown);
        lastY = currentY;
    };

    window.addEventListener('scroll', onScroll, { passive: true });

}

export default detail;
